// Only allow same-origin targets so a login redirect can't send users to an
// external site (e.g. "//evil.com" or "https://evil.com").
export const getSafeRedirectPath = (target: string | null): string | null => {
  if (!target) return null;
  try {
    const url = new URL(target, window.location.origin);
    if (url.origin !== window.location.origin) return null;
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return null;
  }
};
